module.exports = __webpack_public_path__ + "static/img/prod-null.146953e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod-null.png
// module id = Kk/g
// module chunks = 1